<template>
  <a-config-provider :locale="zhCN">
    <div id="app">
      <!-- <router-view v-slot="{ Component }">
        <keep-alive>
          <component class="content" :is="Component" :key="$route.name" />
        </keep-alive>
      </router-view> -->
      <keep-alive include="CouresPage">
        <!-- <router-view v-if="$route.meta.keepAlive"></router-view> -->
        <router-view></router-view>
      </keep-alive>
      <!-- <router-view class="content" v-if="!$route.meta.keepAlive"></router-view> -->
    </div>
  </a-config-provider>
</template>

<script>
import Vue from 'vue'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import { AppDeviceEnquire } from '@/utils/mixin'
import { feachOrgInfo } from '@/api/system'
import { mapMutations } from 'vuex'
import queryString from 'query-string'
export default {
  mixins: [AppDeviceEnquire],
  data() {
    return {
      zhCN,
    }
  },
  created() {
    const url = window.location.href
    console.log('wwwww', url, queryString.parse(location.search))
    this.getOCode(url)
    const contains = url.includes('empty')
    if (!contains) {
      this.getOrgInfo(url)
    }
  },
  mounted() {},
  methods: {
    ...mapMutations(['setOrgInfo']),
    getOCode(url) {
      const substr = url.match(/#(\S*)#/)
      console.log('substr', substr)
      if (substr) {
        Vue.ls.set('code', substr[1])
      } else {
         console.log('qqqq', substr)
      //  this.$router.replace({ name: 'empty' })
        var query = queryString.parse(location.search)
        if (query.sign) {
          return
        }
        if (Vue.ls.get('code') && !query.sign && Vue.ls.get('code') !== query.ocode) {
          Vue.ls.set('code', query.ocode)
          this.$store.dispatch('logout')
          this.$router.replace({ name: 'login' })
        } else {
          console.log('url', url, query)
          Vue.ls.set('code', query.ocode)
        }
      }
      // substr && (Vue.ls.set('code', substr[1]))
    },
    async getOrgInfo(url) {
      try {
        const code = Vue.ls.get('code') ? Vue.ls.get('code') : ''
        Vue.ls.set('code', code)
        if (!code) {
          return
        }
        const res = await feachOrgInfo(code)
        if (!res) {
          this.$router.replace({ name: 'empty' })
          return
        }
        this.setOrgInfo(res)
      } catch (error) {
        console.log(error)
      }
    },
  },
}
</script>
<style>
#app {
  height: 100%;
  background: #f5f8fa;
}

.content {
  height: 100%;
}

.text-center {
  text-align: center;
}
</style>
